// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__eMK3E","imageUploader":"EGiftCard_imageUploader__1SLaN"};